import { IAllInfoUser, IPerson, UserAllResponse } from "app/types/users";
import { toaster } from "app/utilities/commons";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_NET;

/**
 * Get all users for RC
 * @param page 
 * @param pageSize 
 * @returns 
 */
export async function getAllUsers(page: number | string, pageSize: number | string) {
    try {
        const response = await axios.get<UserAllResponse>(`${API_URL}User?Page=${page}&PageSize=${pageSize}`);
        return response.data.data;
    } catch (err) {
        console.error("Error:", err);
        throw err;
    }
}

/**
 * Filter departments by NAME
 * @param page 
 * @param pageSize 
 * @param name 
 * @returns 
 */
export async function getAllUsersFilter(page: number | string, pageSize: number | string, name?: string) {
    let response;
    try {
        response = await axios.get<UserAllResponse>(`${API_URL}User?Name=${name}&Page=${page}&PageSize=${pageSize}`);
        return response.data.data;
    } catch (err) {
        console.error("Error fetching Department");
        throw err;
    }
}

export async function usuarioCreateAndUpdate(body: IAllInfoUser,) {
    let response;
    const { id, idTypePerson, mobile, phone, personalMail, name, paternalSurname, maternalSurname, user,
        userName,
        password,
        email,
        companyId,
        rolId,
        persona,
        fatherLastName,
        motherLastName,
    } = body;
    if (id) {
        try {
            response = await axios.put(`${API_URL}User/${id}`, {
                userName,
                password,
                email,
                companyId,
                rolId,
                id,
                persona,
                name,
                fatherLastName,
                motherLastName
            });
            toaster.success('Se cambio con éxito la información');
            return response.data;
        } catch (err : any) {
            err.response?.data?.errors.forEach((msg : any) =>  {
                toaster.error(msg.message)
            });
            console.error('Error UPDATING role', err);
            throw err;
        }
    } else {
        try {
            response = await axios.post(`${API_URL}Person`, {
                idTypePerson,
                mobile,
                phone,
                personalMail,
                name,
                paternalSurname,
                maternalSurname,
                user
            })
            toaster.success("Guardado correctamente");
            return response.data;
        } catch (err : any) {
            err.response?.data?.errors.forEach((msg : any) =>  {
                toaster.error(msg.message)
            });
            console.error('Error CREATING usuario', err);
            throw err;
        }
    }
}